<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_payment_method_banner.jpg')" alt="入出金方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-subtab-wrap">
          <router-link class="sup-subtab" to="/page/sup-withdraw-bank">
            銀行振込
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-withdraw-mtpay">
            Match Pay
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-withdraw-vega">
            VegaWallet
          </router-link>
          <router-link class="sup-subtab sup-subtab--active" to="/page/sup-withdraw-jeton">
            Jetonbank
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-withdraw-crypto">
            仮想通貨
          </router-link>
        </div>
        <h1 class="sup-page-title">
          Jetonbankでの出金方法
        </h1>
        <div class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 残高表示部分ををタップ</p>
              <p>➋ 「出金」をタップ</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_jeton1.jpg')" alt="ステップ1">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 「eウォレット」を選択</p>
              <p>➋ 使用するJetonbankアカウントを選択</p>
              <p>➌ 金額を入力</p>
              <p>➍ Jetonbankの「7桁数字のユーザーID」を入力</p>
              <p>➎ 出金パスワードを入力</p>
              <p>➏ 「送信する」をタップすると出金申請を提出完了</p>
            </div>
            <p class="sup-step-caution">
              ※出金に使用するJetonbankアカウントは、「決済方法」で事前に登録を完了しておく必要があります。<br>出金口座の登録方法については、「出金口座の登録方法」をご参照ください。<br><a href="https://www.katsuwin.ai/page/sup-account-binding" target="_blank" rel="noopener" style="color:#978564;">https://www.katsuwin.ai/page/sup-account-binding</a>
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_jeton2.jpg')" alt="ステップ2-1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_withdraw_jeton3.jpg')" alt="ステップ2-2">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <p class="sup-step-desc">
              出金申請の審査が終了後に出金が処理完了
            </p>
            <p class="sup-step-caution">
              ※出金申請後に出金審査完了までお待ちください。出金処理が完了すると通知メールが送信されます。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
